import { render, staticRenderFns } from "./payroll-detail.vue?vue&type=template&id=2cbf66f6&scoped=true&"
import script from "./payroll-detail.vue?vue&type=script&lang=js&"
export * from "./payroll-detail.vue?vue&type=script&lang=js&"
import style0 from "./payroll-detail.vue?vue&type=style&index=0&id=2cbf66f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf66f6",
  null
  
)

export default component.exports